import {
  TEXT_FIELD_CHANGED,
  SET_LOADING,
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,

  PARTNER_LOGIN_SUCCESS,
  PARTNER_LOGIN_FAIL,

  PARTNER_UPDATE_ASSISTANT_SUCCESS,

  PARTNER_UPDATE_WEB_SUCCESS,

  RESET_PASSWORD,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_SUCCESS,
  SET_PASSWORD_HASH,
  NEW_PASSWORD_SET,
  NEW_PASSWORD_SET_FAIL,
  NEW_PASSWORD_SET_SUCCESS,
  ERROR_CLEAR,
  EMPLOYEE_AGREEMENT_SUCCESS,
  EMPLOYEE_UPDATE_SUCCESS,
  AUTH_USER_UPDATE_SUCCESS_MERGE,
  EMPLOYER_UPDATE_SUCCESS,
  CLAIM_SUBMIT_SUCCESS,
  EMPLOYER_WELLNESS_SETUP_SUCCESS,
  EMPLOYER_TERMINATE_SUCCESS,
  TOOLS_ACCESS_USER_ACCOUNT_SUCCESS,
  TOOLS_ACCESS_PARTNER_ACCOUNT_SUCCESS,
  EMPLOYER_WELLNESS_TERMINATE_SUCCESS,
  
  EMPLOYER_SET_BANKING_SUCCESS,
  EMPLOYER_GET_BANKING_SUCCESS,
  
  EMPLOYEE_SET_BANKING_SUCCESS,
  EMPLOYEE_GET_BANKING_SUCCESS,

  PARTNER_SET_BANKING_SUCCESS,
  PARTNER_GET_BANKING_SUCCESS,

  EMPLOYER_ENABLE_ONLINE_SUCCESS,
  EMPLOYER_REFUND_BALANCE_SUCCESS,
  EMPLOYER_INSURANCE_FUNDING_SUCCESS,
  LOGOUT,
  LOGIN_TOOLS_SUCCESS,
  AUTH_USER_TOKEN_EXPIRY
} from '../actions/types';

const INITIAL_STATE = {
  id: '',
  pw: '',
  npw1: '',
  npw2: '',
  pwhash: '',
  email: '',
  user: {},
  banking: {},
  claims: [],
  wellnessClaims: [],
  dependants: [],
  services: [],
  wellnessClaimStartDate: null,
  wellnessServices: [],
  wellnessCategories: [],
  persists: false,
  biometryType: null,
  hasCredentials: false,
  accessControl: null,
  loggedIn: false,
  error: false,
  errors: {},
  loading: false,
  token: '',
  expiry: '',
  adList: [],
};

const reducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case TEXT_FIELD_CHANGED:
        return { ...state,
          [action.fieldName]: action.fieldValue
        };
      case SET_LOADING:
        return { ...state, loading: action.payload }
      case LOGIN:
        return { ...state, loading: true, errors: {}, error: false };
      case TOOLS_ACCESS_USER_ACCOUNT_SUCCESS:
        return {
          ...INITIAL_STATE,
          id: '',
          pw: '',
          error: false,
          errors: {},
          loading: false,
          user: action.data.user,
          token: action.data.token,
          expiry: action.data.expiry,
          adList: (action.data.adList)? action.data.adList: [],
          blockList: (action.data.blockList)? action.data.blockList: []
        };
      case TOOLS_ACCESS_PARTNER_ACCOUNT_SUCCESS:
        return {
          ...INITIAL_STATE,
          id: '',
          pw: '',
          error: false,
          errors: {},
          loading: false,
          user: action.data.user,
          token: action.data.token,
          expiry: action.data.expiry,
          adList: (action.data.adList)? action.data.adList: [],
          blockList: (action.data.blockList)? action.data.blockList: []
        };
      case PARTNER_LOGIN_SUCCESS:
        return {
          ...INITIAL_STATE,
          id: '',
          pw: '',
          error: false,
          errors: {},
          loading: false,
          user: action.data.user,
          token: action.data.token,
          expiry: action.data.expiry,
          adList: (action.data.adList)? action.data.adList: [],
          blockList: (action.data.blockList)? action.data.blockList: []
        };
      case PARTNER_LOGIN_FAIL:
        return { ...state, error: true, errors: action.errors, pw: '', loading: false };
      case PARTNER_UPDATE_ASSISTANT_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            ...action.data.assistantInfo,
          },
          error: false,
          errors: {},
          loading: false
        };
      case PARTNER_UPDATE_WEB_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            ...action.data.webInfo,
          },
          error: false,
          errors: {},
          loading: false
        };
      case LOGIN_SUCCESS:
        return {
          ...INITIAL_STATE,
          id: '',
          pw: '',
          error: false,
          errors: {},
          loading: false,
          user: action.data.user,
          token: action.data.token,
          expiry: action.data.expiry,
          adList: (action.data.adList)? action.data.adList: [],
          blockList: (action.data.blockList)? action.data.blockList: []
        };
      case LOGIN_FAIL:
        return { ...state, error: true, errors: action.errors, pw: '', loading: false };
      case AUTH_USER_TOKEN_EXPIRY:
        return { ...state, expiry: action.expiry };
      case RESET_PASSWORD:
        return { ...state, loading: true, errors: {}, error: false };
      case RESET_PASSWORD_SUCCESS:
        return {
          ...state,
          id: '',
          pw: '',
          npw1: '',
          npw2: '',
          pwhash: '',
          email: '',
          error: false,
          errors: {},
          loading: false
        };
      case RESET_PASSWORD_FAIL:
        return { ...state, id: '', email: '', error: true, errors: action.errors, loading: false };
      case SET_PASSWORD_HASH:
        return { ...state, pwhash: action.hash };
      case NEW_PASSWORD_SET:
        return { ...state, loading: true, errors: {}, error: false };
      case NEW_PASSWORD_SET_SUCCESS:
        return {
          ...state,
          npw1: '',
          npw2: '',
          pwhash: '',
          email: '',
          id: '',
          pw: '',
          error: false,
          erros: {},
          loading: false
        };
      case NEW_PASSWORD_SET_FAIL:
        return { ...state, npw1: '', npw2: '', error: true, errors: action.errors, loading: false };
      case ERROR_CLEAR:
        return { ...state, error: false, errors: {}, loading: false };
      case LOGOUT:
        return INITIAL_STATE;
      case EMPLOYEE_AGREEMENT_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            HSA_EMPLOYER_AGREEMENT: (action.data)? action.data.agreement : action.agreement
          }
        };
      case EMPLOYEE_UPDATE_SUCCESS:
        return {
          ...state,
          user: {...state.user, ...(action.data)? action.data.user : action.user},
          error: false,
          errors: {},
          loading: false
        };
      case AUTH_USER_UPDATE_SUCCESS_MERGE:
        return {
          ...state,
          user: {...state.user, ...action.user},
          error: false,
          errors: {},
          loading: false
        };
      case EMPLOYER_UPDATE_SUCCESS:
        return {
          ...state,
          user: {...state.user, ...(action.data.user)? action.data.user: action.user},
          error: false,
          errors: {},
          loading: false
        };
      case CLAIM_SUBMIT_SUCCESS:
        return {
          ...state,
          claims: action.data.claims,
          wellnessClaims: action.data.wellnessClaims,
          user: {
            ...state.user,
            BALANCE: action.data.balance,
            SPENDABLE_PREVIOUS_BALANCE: action.data.spendablePreviousBalance,
            WELLNESS_BALANCE: action.data.wellnessBalance,
            EMPLOYEE_AUDIT_STATE: action.data.auditState
          }
        };
      case EMPLOYER_WELLNESS_SETUP_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            ...action.data.authWellness
          }
        }
      case EMPLOYER_WELLNESS_TERMINATE_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            ...action.data.authWellness
          }
        }
      case EMPLOYER_SET_BANKING_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            MISSING_COMPANY_BANKING: action.data.user.MISSING_COMPANY_BANKING,
            EMPLOYER_CHEQUE_VERIFY_REQUIRED: action.data.user.EMPLOYER_CHEQUE_VERIFY_REQUIRED,
          }
        }
      case EMPLOYER_GET_BANKING_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            MISSING_COMPANY_BANKING: action.data.user.MISSING_COMPANY_BANKING,
            EMPLOYER_CHEQUE_VERIFY_REQUIRED: action.data.user.EMPLOYER_CHEQUE_VERIFY_REQUIRED,
          }
        }
      case EMPLOYEE_SET_BANKING_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            MISSING_BANKING: action.data.user.MISSING_BANKING,
            EMPLOYEE_CHEQUE_VERIFY_REQUIRED: action.data.user.EMPLOYEE_CHEQUE_VERIFY_REQUIRED,
            PAYMENT_RESTRICTION: action.data.user.PAYMENT_RESTRICTION
          }
        }
      case EMPLOYEE_GET_BANKING_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            MISSING_BANKING: action.data.user.MISSING_BANKING,
            EMPLOYEE_CHEQUE_VERIFY_REQUIRED: action.data.user.EMPLOYEE_CHEQUE_VERIFY_REQUIRED,
          }
        }
      case PARTNER_SET_BANKING_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            MISSING_PARTNER_BANKING: action.data.user.MISSING_PARTNER_BANKING,
            AGENT_CHEQUE_VERIFY_REQUIRED: action.data.user.AGENT_CHEQUE_VERIFY_REQUIRED,
          }
        }
      case PARTNER_GET_BANKING_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            MISSING_PARTNER_BANKING: action.data.user.MISSING_PARTNER_BANKING,
            AGENT_CHEQUE_VERIFY_REQUIRED: action.data.user.AGENT_CHEQUE_VERIFY_REQUIRED,
          }
        }
      case EMPLOYER_ENABLE_ONLINE_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            ONLINE_CLAIM_OK: 'Y'
          }
        }
      case EMPLOYER_REFUND_BALANCE_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            ...action.data.refundBalance
          }
        }
      case EMPLOYER_INSURANCE_FUNDING_SUCCESS:
        return {
          ...state,
          user: {
            ...state.user,
            ...action.data.insuranceFunding
          }
        }
      case LOGIN_TOOLS_SUCCESS:
        return { ...state, id: '', pw: '', error: false, errors: {}, loading: false };
      case EMPLOYER_TERMINATE_SUCCESS:
        return INITIAL_STATE;
      default:
        return state;
    }
};

export default reducer;
